export default [
  {
    path: '/settings/integrations',
    name: 'app-adm-settings-integrations',
    component: () => import('@/views/apps/settings/integrations/SettingsIntegrations.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Integrações',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [
        {
          text: 'Configurações',
          active: true,
        },
        {
          text: 'Integrações',
          active: true,
        },
      ],
    },
  },
]
